module.exports = __webpack_public_path__ + "static/david-kerr-90f031da64485f2bd62344adc8ed2ac5.jpg";